import React from "react";

export const Doctors = () => {
  return (
    <div>
      <h1 className="text-center">Doctors Page</h1>
    </div>
  );
};
